import { styled, theme, utils } from 'ui/theme';

const Logo = styled.svg`
  height: 100%;
  color: ${theme.colors.build.darkLight};

  &[data-brand='bot'] {
    color: #5f5e5e;
    height: 41px;
    max-width: 163px;
    width: 163px;

    ${utils.media.max('m')`
      max-width: 112px;
      width: 112px;
    `}
  }

  &[data-multibrand='true'] {
    color: #5f5e5e;
    height: 41px;
    max-width: 195px;
    width: 195px;

    ${utils.media.max('l')`
      max-width: 135px;
      width: 135px;
    `}
  }

  &[data-color='primary'] {
    color: ${theme.colors.build.brand1};
  }

  &[data-color='secondary'] {
    color: ${theme.colors.build.brand2};
  }

  &[data-color='tertiary'] {
    color: ${theme.colors.build.brand3};
  }

  &[data-color='light'] {
    color: ${theme.colors.build.lightLight};
  }

  path {
    fill: currentColor;
  }
`;

export default Logo;
